import useLocation from "@hooks/useLocation"
import { parseResultsUrl } from "@lib/searchUtils"

const useUrlData = () => {
  const location = useLocation()
  const pageUrlData = parseResultsUrl(location)

  return pageUrlData
}

export default useUrlData
